// Vue section
import Vue from 'vue/dist/vue.esm';
import { ROOT_DELIMITERS } from '../services/vue_root'
import { toastText } from '../services/toast'
import VueResource from 'vue-resource'
import Vue2Filters from 'vue2-filters'
import ImageUploader from 'vue-image-upload-resize'

// Custom components
import byCard from 'components/checkout_sessions/by_card'
import byCheck from 'components/checkout_sessions/by_check'
import byAch from 'components/checkout_sessions/by_ach'
import forServiceTitan from 'components/checkout_sessions/for_service_titan'

// Card elements
import stripeCardElement from 'components/merchant/cards/elements/stripe_card_element'
import genericCardElement from 'components/merchant/cards/elements/public_generic_card_element'
import setupIntentElement from 'components/merchant/cards/elements/setup_intent_element'
import adyenCardElement from 'components/merchant/cards/elements/adyen_card_element'

// 3d party components
import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faEnvelope, faPhone, faUser, faHandHoldingUsd, faSpinner, faCreditCard, faFileInvoice, faStickyNote, faCheck, faDollarSign, faRandom, faHashtag, faArrowLeft, faMoneyCheck, faExclamationTriangle, faInfoCircle, faCamera, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons'
import { faCcVisa } from '@fortawesome/free-brands-svg-icons'
import VeeValidate from 'vee-validate'
// Side-effect import: Materialize sets window.M, which toasts and components use as a global.
// A named import that is never referenced is dropped by the TypeScript preset.
import '../stylesheets/materialize-src/js/bin/materialize'
import VueMask from 'v-mask'

import '../stylesheets/checkout_session.scss'

library.add(faEnvelope, faPhone, faUser, faSpinner, faCreditCard, faHandHoldingUsd, faFileInvoice, faStickyNote, faCcVisa, faCheck, faDollarSign, faRandom, faHashtag, faArrowLeft, faMoneyCheck, faExclamationTriangle, faInfoCircle, faCamera, faMapMarkerAlt)

Vue.use(Vue2Filters)
Vue.use(VueResource)
Vue.use(ImageUploader)
Vue.use(VeeValidate,
  {
    classes: true,
    classNames: {
      valid: 'valid',
      invalid: 'invalid'
    }
  });
Vue.use(VueMask);

Vue.http.headers.common['X-CSRF-Token'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content')

Vue.component('by-card', byCard)
Vue.component('by-check', byCheck)
Vue.component('by-ach', byAch)
Vue.component('for-service-titan', forServiceTitan)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('stripe-card-element', stripeCardElement)
Vue.component('generic-card-element', genericCardElement)
Vue.component('setup-intent-element', setupIntentElement)
Vue.component('adyen-card-element', adyenCardElement)

document.addEventListener('DOMContentLoaded', () => {
  const app = new Vue({
    el: '[data-behavior="vue"]',
    delimiters: ROOT_DELIMITERS
  })
})

// Configure Events bus
const bus = new Vue()
Vue.prototype.$bus = bus
Vue.prototype.$dom = dom

Vue.prototype.$webkit = window.webkit;
Vue.prototype.$android = window.Android;
Vue.mixin({
  data: function () {
    return {
    }
  },
  methods: {
    notifyError(message) {
      toastText(message, 'red darken-1')
    },
    notifySuccess(message) {
      toastText(message, 'emerald-back')
    },
    errorHandler(error) {
      if (error.status == 422) {
        this.notifyError(error.body.error_messages[0])
      } else if (error.status == 413) {
        this.notifyError('File is too large. Please use a smaller file.')
      } else if (error.status == 429) {
        this.notifyError('Too many requests. Please try again later')
      }
      else {
        this.notifyError('Something went wrong')
      }
    }
  }
})
